import { TYourWayIframeUrl } from './types'
import client from '../../client'
import { ResponseSuccess } from '../../types'

export const getYourWayIframeUrl = async () =>
  await client.get<ResponseSuccess<TYourWayIframeUrl>>(`v1/seu-jeito/iframe-url`)
